module.exports = __webpack_public_path__ + "static/media/Products (13).dd3ad3b1.jpeg";